import React, { Component } from "react";


const HeaderAgcu = ({ title, subtitle, page }) => {
	require("./HeaderAgcu.css");
	return (
		<div className="card-header head-pnl">
			<div className="pnl-page1">
				<div className="card-page1">{page}</div>
				<div className="label-link">https://eduprime.co.id/</div>
			</div>

			<div className="flex-header">
				<div className="wrap-header-content">
					<div className="title-header2">{title}</div>
					<div className="label-subTit">{subtitle}</div>
				</div>
				<div className="pnl-right-header">
					Report Dinas
				</div>
			</div>
		</div>
	);
}

export default HeaderAgcu;
